import { useAlert } from 'components/alert'
import useSession from 'components/auth/useSession'
import { Box } from 'components/Box'
import useFirebase from 'components/firebase/useFirebase'
import { FormApi } from 'final-form'
import { useInserirMunicipioResponsavelMutation } from 'graphql/hooks.generated'
import React from 'react'

import MunicipioResponsavelFormModel, { MunicipioResponsavelForm } from './MunicipioResponsavelForm'

export interface MunicipioResponsavelInsertProps {
  profissional: {
    id: ID
    nome: string
  }
  localidade: {
    id: ID
    nome: string
    uf: string
  }
  onInsertCompleted(): Promise<any>
}

export const MunicipioResponsavelInsert = (props: MunicipioResponsavelInsertProps) => {
  const { profissional, onInsertCompleted, localidade } = props
  const alert = useAlert()
  const session = useSession()

  const [createMunicipioResponsavel] = useInserirMunicipioResponsavelMutation()
  const { analytics } = useFirebase()

  const handleSubmit = (values: MunicipioResponsavelFormModel, form: FormApi) => {
    return createMunicipioResponsavel({
      variables: {
        input: {
          localidade: values.localidade.id,
          profissional: values.profissional.id,
        },
      },
    }).then((res) => {
      const data = res && res.data.inserirMunicipioResponsavel
      analytics.logEvent('add_municipio_responsavel', { Município: data.municipio.nome })
      values.profissional.id === session.data.profissional.id && session.refresh()
      alert(
        'success',
        <>
          Município {data.municipio.nome} e responsável {data.profissional.nome} salvos com sucesso.
          <br />O acesso de Administrador Municipal foi adicionado ao profissional {data.profissional.nome}
        </>
      )
      onInsertCompleted()
      setTimeout(form.reset)

      return res
    })
  }

  return (
    <Box>
      <MunicipioResponsavelForm
        onSubmit={handleSubmit}
        initialValues={
          {
            profissional: profissional.id ? profissional : null,
            localidade: localidade.id ? localidade : null,
          } as any
        }
      />
    </Box>
  )
}
